import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, List, ListItem, Divider } from '@mui/material';
import { formatDistance } from '../../utils/utils';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import { useTranslation } from 'next-i18next';

interface INearbyLocationTabsProps {
  data: any;
  locale: string;
}

const NearbyLocationTabs = ({ data, locale }: INearbyLocationTabsProps) => {
  const { t } = useTranslation();
  const [initLoading, setInitLoading] = useState(true);
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState<any[]>([]);
  const [count, setCount] = useState(8);
  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    const newData = data.slice(0, count);
    setList(newData);
    setInitLoading(false);
  }, [count, data]);

  const onToggle = () => {
    setLoading(true);
    setTimeout(() => {
      if (showAll) {
        setCount(8);
      } else {
        setCount(data.length);
      }
      setShowAll(!showAll);
      setLoading(false);
    }, 300);
  };

  return (
    <Box>
      <List
        disablePadding
        sx={{ borderBottomLeftRadius: 10, borderBottomRightRadius: 10, boxShadow: '0px 2px 10px 0px #0000001A' }}
      >
        {list.map((item, index) => (
          <Box key={index}>
            <ListItem
              sx={{
                py: 1.5,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <Typography variant="body2">
                {`${item.location_type_ID != 10 ? item[`Name_${locale.toUpperCase()}`] || '' : ''} ${
                  item[`branch_Name_${locale.toUpperCase()}`] || item[`Name_${locale.toUpperCase()}`]
                }`}
              </Typography>
              <Typography variant="body2" whiteSpace="nowrap">
                {item.distance ? `${formatDistance(Number(item.distance), t)}` : ''}
              </Typography>
            </ListItem>
            {index < list.length - 1 && <Divider component="li" />}
          </Box>
        ))}
      </List>

      {!initLoading && data.length > 8 && (
        <Box mt={2} textAlign="center">
          <Button
            variant="text"
            size="small"
            onClick={onToggle}
            disabled={loading}
            endIcon={
              showAll ? (
                <RemoveCircleOutlineIcon sx={{ color: (theme) => theme.palette.primary.main }} />
              ) : (
                <ControlPointIcon sx={{ color: (theme) => theme.palette.primary.main }} />
              )
            }
            sx={{
              color: '#000',
              textTransform: 'none',
              '&:hover': {
                color: (theme) => theme.palette.primary.main,
                backgroundColor: 'transparent',
              },
            }}
          >
            {showAll ? t('nearbyLocation.showLess') : t('nearbyLocation.loadMore')}
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default NearbyLocationTabs;
